import { insurances } from "@wayke-se/ecom";
import { validateInsurance } from "../tools/data-validation";
export const getInsuranceOptions = (data, callback) => {
    const isValidRequestData = validateInsurance(data.ecomData);
    if (!isValidRequestData) {
        return callback(null);
    }
    const request = insurances
        .newInsuranceOptionsRequest()
        .forCustomer(data.ecomData.personalNumber)
        .forVehicle(data.vehicleId)
        .withPaymentType(data.paymentType)
        .withDrivingDistance(data.ecomData.expectedDrivingDistance)
        .build();
    insurances
        .getOptions(request)
        .then((response) => {
        callback(response);
    })
        .catch(() => {
        callback(null);
    });
};
